import FacilitiesView from '@Facility/views/Facilities.vue';
import FacilityView from '@Facility/views/Facility.vue';
const DocumentViewerPage = () => import('@Facility/views/DocumentViewerPage.vue');

import MainView from '@/views/MainView.vue';

export default [
  {
    path: '/',
    name: 'facilities',
    component: FacilitiesView,
    meta: {
      requiresAuth: true,
      title: 'Facilities',
    },
  },
  {
    path: '/:id',
    component: FacilityView,
    children: [
      {
        path: '',
        name: "facility",
        component: MainView,
        meta: {
          requiresAuth: true,
          layout: 'viewer-layout',
        },
      },
      {
        path: 'viewer',
        name: 'RealityViewer',
        component: MainView,
        meta: {
          requiresAuth: true,
          layout: 'viewer-layout',
        },
      },
    ],
    meta: {
      requiresAuth: true,
      title: 'Facility',
      layout: 'viewer-layout',
      facilityScope: true,
    },
  },
];

/**
 * A document on its own page (PDF.js viewer, no 3D / APS viewer); the AVA Inspection report links here.
 * Registered before taskRoutes in the router, or /:id/:taskTypeId would take /:id/document/….
 */
export const facilityDocumentRoutes = [
  {
    path: '/:id/document/:documentId',
    name: 'facility-document',
    component: DocumentViewerPage,
    meta: {
      requiresAuth: true,
      title: 'Document',
      layout: 'auth-layout',
      facilityScope: true,
    },
  },
];
